module.exports = __webpack_public_path__ + "static/media/logoPagImovel.861b3b4f.svg";